import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TNotification } from "@commons/types";

interface INotification {
  type?: TNotification;
  message: string;
  time?: number;
}

interface IDialog {
  key: string;
  visable: boolean;
  component?: any;
  data?: any;
}

export interface IGeneral {
  drawers: {
    left: {
      isOpen: boolean;
    };
    bottom: {
      isOpen: boolean;
    };
  };
  dialogs: IDialog[];
  actions: {
    isOpen: boolean;
    selectedIDs: any;
  };
  notifications: INotification[];
  filters: null;
}

const initialState: IGeneral = {
  drawers: {
    left: {
      isOpen: false,
    },
    bottom: {
      isOpen: false,
    },
  },
  actions: {
    isOpen: false,
    selectedIDs: [],
  },
  dialogs: [],
  notifications: [],
  filters: null,
};

export const ProfileSlice = createSlice({
  name: "General",
  initialState,
  reducers: {
    openLeftDrawer(state: IGeneral) {
      state.drawers.left.isOpen = true;
    },
    closeLeftDrawer(state: IGeneral) {
      state.drawers.left.isOpen = false;
    },
    openBottomDrawer(state: IGeneral) {
      state.drawers.bottom.isOpen = true;
    },
    closeBottomDrawer(state: IGeneral) {
      state.drawers.bottom.isOpen = false;
    },
    openDialog(state: IGeneral, action: PayloadAction<IDialog>) {
      state.dialogs.push(action.payload);
    },
    closeDialog(state: IGeneral, action: PayloadAction<string>) {
      const temp = state.dialogs.find((D) => D.key === action.payload);
      if (temp) {
        const index = state.dialogs.indexOf(temp);
        if (index !== -1) {
          state.dialogs = [
            ...state.dialogs.slice(0, index),
            ...state.dialogs.slice(index + 1),
          ];
        }
      }
    },
    clearDialog(state: IGeneral) {
      state.dialogs = [];
    },
    showNotification(state: IGeneral, action: PayloadAction<INotification>) {
      state.notifications.push(action.payload);
    },
    showActions(state: IGeneral, action) {
      state.actions.isOpen = true;
      state.actions.selectedIDs = action.payload;
    },
    hideActions(state: IGeneral) {
      state.actions.isOpen = false;
      state.actions.selectedIDs = [];
    },
    saveFilter(state: IGeneral, action: PayloadAction<any>) {
      state.filters = action.payload;
    },
    clearFilter(state: IGeneral) {
      state.filters = null;
    },
  },
  extraReducers: {},
});

export type { INotification, IDialog };
export const {
  showActions,
  hideActions,
  openDialog,
  closeDialog,
  clearDialog,
  openLeftDrawer,
  closeLeftDrawer,
  openBottomDrawer,
  saveFilter,
  clearFilter,
  closeBottomDrawer,
  showNotification,
} = ProfileSlice.actions;
export default ProfileSlice.reducer;
